import React from "react";

export function normalizeGeneratedKind(value) {
  const key = String(value || "").trim().toLowerCase();
  if (key === "return" || key === "returns") return "return";
  return "register";
}

